document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('scrollToTopBtn');

    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) {
        btn.style.display = 'block';
      } else {
        btn.style.display = 'none';
      }
    });

    btn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });